import { FormCard } from '@qbe/ads-blocks-forms';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppContent } from '~/hooks';

const CoverDetails: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.coverDetails' });
  return (
    <>
      <FormCard
        data-testid="cover-details"
        variant="pageTitle"
        title={getTextContent('title')}
        description={getTextContent('description')}
      />
      <Outlet />
    </>
  );
};

export default CoverDetails;
